import {
  array,
  boolean,
  enumType,
  number,
  object,
  optional,
  string,
} from "valibot";

export const LocaleSchema = enumType([
  "en",
  "es",
  "fr",
  "pt",
  "pt-pt",
  "pt-br",
  "de",
  "it",
  "nl",
  "pl",
  "ru",
  "ja",
  "zn",
  "bg",
  "cs",
  "da",
  "el",
  "hu",
  "lt",
  "lv",
  "ro",
  "sk",
  "sl",
  "sv",
  "fi",
  "et",
  "zh",
]);

export const CommandSchema = object({
  widget: optional(enumType(["open", "close"])),
  showWelcomeMessage: optional(boolean()),
  setWelcomeMessage: optional(string()),
  showStarterQuestions: optional(boolean()),
  setStarterQuestions: optional(array(string())),
});

export const ActionSchema = object({
  urls: array(string()),
  scrollPercentage: optional(number()),
  timeout: optional(number()),
  commands: array(CommandSchema),
});

export const ActionsSchema = array(ActionSchema);

export const ActionsEventSchema = object({
  actions: ActionsSchema,
});

export const ParentWindowSizeSchema = object({
  innerWidth: number(),
  innerHeight: number(),
});

export const ParentWindowScrollSchema = object({
  scrollPercentage: number(),
});
